import { render, staticRenderFns } from "./afterDeal.vue?vue&type=template&id=0d736c02"
import script from "./afterDeal.vue?vue&type=script&lang=js"
export * from "./afterDeal.vue?vue&type=script&lang=js"
import style0 from "./afterDeal.vue?vue&type=style&index=0&id=0d736c02&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports